import React, { useEffect, useState } from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { Clock } from 'lucide-react';
export function CountdownPricing() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 24,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return {
          hours: 24,
          minutes: 59,
          seconds: 59
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (val: number) => val.toString().padStart(2, '0');
  return <section id="pricing" className="py-20 relative" data-id="element-51">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-52">
        <FadeIn className="text-center mb-12" data-id="element-53">
          <div className="inline-flex items-center gap-2 text-red-400 font-bold mb-4" data-id="element-54">
            <Clock className="w-5 h-5 animate-pulse" data-id="element-55" />⏰ PRECIO DE LANZAMIENTO
            — CIERRA EN:
          </div>

          <div className="flex justify-center items-baseline gap-1 mb-2" data-id="element-56">
            <span className="md:text-8xl lg:text-9xl font-extrabold text-red-500 tabular-nums tracking-tight text-[82px]" data-id="element-57">
              {formatTime(timeLeft.hours)}
            </span>
            <span className="md:text-8xl lg:text-9xl font-extrabold text-red-500 text-[72px]" data-id="element-58">
              :
            </span>
            <span className="md:text-8xl lg:text-9xl font-extrabold text-red-500 tabular-nums tracking-tight text-[72px]" data-id="element-59">
              {formatTime(timeLeft.minutes)}
            </span>
            <span className="md:text-8xl lg:text-9xl font-extrabold text-red-500 text-[72px]" data-id="element-60">
              :
            </span>
            <span className="md:text-8xl lg:text-9xl font-extrabold text-red-500 tabular-nums tracking-tight text-[62px]" data-id="element-61">
              {formatTime(timeLeft.seconds)}
            </span>
          </div>

          <div className="flex justify-center gap-16 md:gap-24 mb-8" data-id="element-62">
            <span className="text-sm text-slate-400 uppercase tracking-widest" data-id="element-63">
              HS
            </span>
            <span className="text-sm text-slate-400 uppercase tracking-widest" data-id="element-64">
              MIN
            </span>
            <span className="text-sm text-slate-400 uppercase tracking-widest" data-id="element-65">
              SEG
            </span>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} className="text-center mb-10" data-id="element-66">
          <h2 className="text-4xl font-bold" data-id="element-67">💰 ELEGÍ TU MEGAPACK</h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-68">
          {/* Tier 1 */}
          <FadeIn delay={0.3} data-id="element-69">
            <div className="bg-brand-card border border-slate-700 rounded-3xl p-8 h-full flex flex-col relative" data-id="element-70">
              <div className="mb-6" data-id="element-71">
                <h3 className="text-2xl font-bold text-white mb-2 flex items-center gap-2" data-id="element-72">
                  📘 MEGAPACK CONTADOR PRO
                </h3>
                <p className="text-brand-accent font-medium mb-4" data-id="element-73">
                  6 Tomos + 4 Bonos
                </p>
                <p className="text-slate-400 text-sm" data-id="element-74">
                  Ideal para: Contador independiente que quiere automatizar,
                  cobrar mejor y recuperar su tiempo
                </p>
              </div>

              <div className="mb-8" data-id="element-75">
                <div className="text-slate-500 line-through text-lg mb-1" data-id="element-76">
                  $51.000
                </div>
                <div className="text-4xl font-bold text-white flex items-baseline gap-1" data-id="element-77">
                  $19.990{' '}
                  <span className="text-lg text-slate-400 font-normal" data-id="element-78">
                    ARS
                  </span>
                </div>
              </div>

              <div className="mt-auto" data-id="element-79">
                <Button href="https://librofy.store/products/megapack-contador-pro?variant=47834891485405" fullWidth variant="outline" className="mb-4" data-id="element-80">
                  → QUIERO MI MEGAPACK CONTADOR PRO
                </Button>
              </div>
            </div>
          </FadeIn>

          {/* Tier 2 */}
          <FadeIn delay={0.4} data-id="element-81">
            <div className="bg-gradient-to-b from-brand-card to-brand-darker border-2 border-brand-accent rounded-3xl p-8 h-full flex flex-col relative transform md:-translate-y-4 shadow-[0_0_40px_rgba(245,158,11,0.15)]" data-id="element-82">
              <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-brand-accent text-brand-darker font-bold px-4 py-1 rounded-full text-sm uppercase tracking-wider" data-id="element-83">
                Más Elegido
              </div>

              <div className="mb-6" data-id="element-84">
                <h3 className="text-2xl font-bold text-white mb-2 flex items-center gap-2" data-id="element-85">
                  🏆 MEGAPACK PRO + SISTEMA CLIENTES ⭐
                </h3>
                <p className="text-brand-accent font-medium mb-4" data-id="element-86">
                  6 Tomos + 4 Bonos + Kit de Captación Premium
                </p>
                <p className="text-slate-300 text-sm" data-id="element-87">
                  Ideal para: Contador que además quiere captar clientes nuevos,
                  posicionarse en LinkedIn y lanzar el servicio CFO
                  Externalizado
                </p>
              </div>

              <div className="mb-8" data-id="element-88">
                <div className="text-slate-500 line-through text-lg mb-1" data-id="element-89">
                  $69.000
                </div>
                <div className="text-5xl font-bold text-white flex items-baseline gap-1" data-id="element-90">
                  $27.990{' '}
                  <span className="text-lg text-slate-400 font-normal" data-id="element-91">
                    ARS
                  </span>
                </div>
              </div>

              <div className="mt-auto" data-id="element-92">
                <Button href="https://librofy.store/products/megapack-contador-pro-sistema-clientes?variant=47834891976925" fullWidth size="xl" className="mb-4" data-id="element-93">
                  → QUIERO EL MEGAPACK PRO + SISTEMA CLIENTES ⭐
                </Button>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}